import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { EmbeddedVideoElement } from '../../types';

export const EMBEDDED_VIDEO_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'embedded-video': (node: EmbeddedVideoElement) => {
        const title = node.title ? ` title="${escapeHTML(node.title)}"` : '';
        return `<iframe class="wrex-embedded-video" src="${escapeHTML(node.url || '')}"${title}></iframe>`;
    },
};
